import Vue from 'vue';
import VueRouter from 'vue-router';

import authRoutes from '@/router/authRoutes';
import mainRoutes from '@/router/mainRoutes';
// eslint-disable-next-line import/no-cycle
import { analytics } from '@/services/analytics';

Vue.use(VueRouter);

let routesApp = [];

routesApp = [].concat(authRoutes, mainRoutes);

const router = new VueRouter({
  mode: 'history',
  routes: routesApp,
  base: process.env.BASE_URL,
});

router.afterEach((to) => {
  const excluir = ['ForgotPassword', 'Login', 'RecuperarSenha'];
  if (!excluir.includes(to.name)) {
    analytics(to.name);
  }
});

export default router;
